$(function () {
  var webStorage = function () {
    if (sessionStorage.getItem('access')) {
      /*
        2回目以降アクセス時の処理
      */
      $(".loading-overlay").addClass('is-active');
    } else {
      /*
        初回アクセス時の処理
      */
      sessionStorage.setItem('access', 'true'); // sessionStorageにデータを保存
      $(".loading-animation").addClass('is-active'); // loadingアニメーションを表示
      document.body.classList.add('lock-scroll'); // スクロールを無効にする

      setTimeout(function () {
        // ローディングを数秒後に非表示にする
        $(".loading-overlay").addClass('is-active');
        $(".loading-animation").removeClass('is-active');
        document.body.classList.remove('lock-scroll'); // スクロールを有効にする
      }, 3000); // ローディングを表示する時間
    }
  };

  webStorage();
});

// ページのロード中にスクロールが無効になっているかを確認する
var isScrollDisabled = function() {
    return document.body.classList.contains('lock-scroll');
};

// テスト
console.log(isScrollDisabled()); // true（スクロールが無効）または false（スクロールが有効）
